import { auth } from '@/firebase';
import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    "X-Authentication-ID": null,
  },
})

// The Firebase ID token of the logged-in editor on every request. Since axios 1 the headers are an
// AxiosHeaders object: set the one header instead of replacing them all.
instance.interceptors.request.use(async config => {
  const token = await auth().currentUser?.getIdToken();
  if (token) config.headers.set("X-Authentication-ID", token);
  return config;
}, error => {
  return Promise.reject(error);
})


export default instance;